import { HelpCircle, Bell, Mail, Settings, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const TopBar = () => {
  const { user, logoutUser } = useAuth();
  return (
    <div className="h-16 bg-white shadow-sm flex justify-between items-center px-8 w-full z-10 sticky top-0 border-b border-gray-200">
      {/* Left side empty or Breadcrumbs placeholder */}
      <div>
        <span className="text-sm font-medium text-gray-500 tracking-wide uppercase">
          {user?.cliente ? user.cliente.nombre : 'Hunter+ Admin'}
        </span>
      </div>

      {/* Right Actions */}
      <div className="flex items-center gap-6">
        <div className="flex gap-4 text-gray-400">
          <HelpCircle size={18} className="cursor-pointer hover:text-[#00a99d] transition-colors" />
          <Bell size={18} className="cursor-pointer hover:text-[#00a99d] transition-colors" />
          <Mail size={18} className="cursor-pointer hover:text-[#00a99d] transition-colors" />
          <Settings size={18} className="cursor-pointer hover:text-[#00a99d] transition-colors" />
        </div>
        
        <div className="h-6 w-px bg-gray-200"></div>
        
        <div className="flex items-center gap-3 cursor-pointer group">
          <div className="flex flex-col items-end">
            <span className="text-xs font-bold text-gray-700">{user?.nombre || 'Mi Cuenta'}</span>
            <span className="text-[10px] text-gray-400 uppercase">{user?.rol === 'superadmin' ? 'Super Admin' : 'Portal Cliente'}</span>
          </div>
          <div className="w-8 h-8 rounded-full bg-[#2C4F1A] flex items-center justify-center text-white font-bold uppercase">
             {user?.nombre?.[0] || 'U'}
          </div>
        </div>
        
        <div className="h-6 w-px bg-gray-200"></div>

        <button 
          onClick={logoutUser}
          className="flex items-center gap-2 text-xs font-bold text-gray-400 hover:text-red-500 transition-colors uppercase"
        >
          <LogOut size={14} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default TopBar;
